import React, { Component } from 'react';
import { Row, Col, Modal, ModalBody, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
import Moment from 'react-moment';
class ActivityDetail extends Component {
  from = '';
  item = {};
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      details: {},
      isLoading: false,
      title: 'Activity'
    }
    this.toggle = this.toggle.bind(this);
  }

  toggle(data) {
    let { title } = this.state;
    if (data && data.activity_name && data.activity_name.toLowerCase() === 'scrap analysis') {
      title = 'Activity - Scrap Analysis';
    } else if (data && data.activity_name && data.activity_name.toLowerCase() === 'driver training') {
      title = 'Activity - Driver Training';
    } else if (data && data.activity_name && data.activity_name.toLowerCase() === 'heal the wheel') {
      title = 'Activity - Heal the wheel';
    }  else if (data && data.activity_name && data.activity_name.toLowerCase() === 'digital training') {
      title = 'Activity - Digital Training';
    } else {
      title = 'Activity'
    }
    this.setState(prevState => ({
      ...prevState,
      modal: !prevState.modal,
      details: data,
      title
    }));
  }
  render() {
    let { details } = this.state;
    const externalCloseBtn = <button className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={this.toggle}>&times;</button>;
    return (
      <>
        {this.state.isLoading && <CustomSpinner />}
        <Modal isOpen={this.state.modal} toggle={this.toggle} external={externalCloseBtn} className="modal-md modal-lg custom-confirm-modal width-40-pecentage" style={{ maxWidth: '1600px' }} backdrop={this.backdrop ? 'static' : 'nostatic'}>
          <div className="d-flex-column">
            <div className="confirm-modal-title-wrapp">
              <span className="confirm-modal-title">{this.state.title}</span>
              <FontAwesomeIcon className="pull-right cursor-pointer" onClick={() => this.toggle({})} icon={faTimes} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
            </div>
          </div>
          <ModalBody classNam="d-flex-column" id="activity-deatil">
            <div className="activity-detail">
              <Row>
                <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                  <Label for="company_name" className="mb-1">Activity Date</Label>
                  <span className="detail-lbl font-weight-bold text-capitalize">
                    {
                      details.activity_date ?
                        <Moment format="MMM DD YYYY">
                          {details.activity_date}
                        </Moment> :
                        '--'}
                  </span>
                </Col>
                <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                  <Label for="company_name" className="mb-1">Created On</Label>
                  <span className="detail-lbl font-weight-bold text-capitalize">
                    {
                      details.created_at ?
                        <Moment format="MMM DD YYYY">
                          {details.created_at}
                        </Moment> :
                        '--'}
                  </span>
                </Col>
                <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                  <Label for="company_name" className="mb-1">Member Code</Label>
                  <span className="detail-lbl font-weight-bold text-capitalize">
                    {details.member_id ? details.member_id : '--'}
                  </span>
                </Col>
              </Row>
              {
                details.activity_name && details.activity_name.toLowerCase() === 'scrap analysis' &&
                <Row>
                  <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                    <Label for="company_name" className="mb-1">No Of Tyres</Label>
                    <span className="detail-lbl font-weight-bold text-capitalize">
                      {details.number_of_tyres_inspected ? details.number_of_tyres_inspected : '--'}
                    </span>
                  </Col>
                  <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                    <Label for="company_name" className="mb-1">Average NSD</Label>
                    <span className="detail-lbl font-weight-bold text-capitalize">
                      {details.average_nsd ? details.average_nsd : '--'}
                    </span>
                  </Col>
                  <Col xl="12" md="12" xs="12" className='d-flex-column mb-3'>
                    <Label for="company_name" className="mb-1">Major cause of removal</Label>
                    <span className="detail-lbl font-weight-bold text-capitalize">
                      {details.major_cause_of_removal ? details.major_cause_of_removal : '--'}
                    </span>
                  </Col>
                  <Col xl="12" md="12" xs="12" className='d-flex-column mb-3'>
                    <Label for="company_name" className="mb-1">Solutions Given</Label>
                    <span className="detail-lbl font-weight-bold text-capitalize">
                      {details.solution_given ? details.solution_given : '--'}
                    </span>
                  </Col>
                </Row>
              }

              {
                details.activity_name && details.activity_name.toLowerCase() === 'heal the wheel' &&
                <>
                  <Row>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">No. of vehicles</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.number_of_vehicles_inspected ? details.number_of_vehicles_inspected : '--'}
                      </span>
                    </Col>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">No. of wheels</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.number_of_wheels_inspected ? details.number_of_wheels_inspected : '--'}
                      </span>
                    </Col>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Average Inflation pressure noted</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.average_inflation_pressure_noted ? details.average_inflation_pressure_noted : '--'}
                      </span>
                    </Col>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Alignment Practices</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.select_alignment_practices ? details.select_alignment_practices : '--'}
                      </span>
                    </Col>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Rotation Practices</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.select_rotation_practices ? details.select_rotation_practices : '--'}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Front Axel Brand</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.front_axel_brand ? details.front_axel_brand : '--'}
                      </span>
                    </Col>
                    {/* <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Front Axel Brand</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.front_axel_brand ? details.front_axel_brand : '--'}
                      </span>
                    </Col> */}
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Front Axel Pattern</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.front_axel_pattern ? details.front_axel_pattern : '--'}
                      </span>
                    </Col>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Rear Axel Brand</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.rear_axel_brand ? details.rear_axel_brand : '--'}
                      </span>
                    </Col>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Rear Axel Pattern</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.rear_axel_pattern ? details.rear_axel_pattern : '--'}
                      </span>
                    </Col>
                    <Col xl="12" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Major Observation</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.major_observation ? details.major_observation : '--'}
                      </span>
                    </Col>
                  </Row>
                </>
              }
              {
                details.activity_name && (details.activity_name.toLowerCase() === 'driver training' || details.activity_name.toLowerCase() === 'digital training') &&
                <>
                  <Row>
                    <Col xl="4" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">No. of participants</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.number_of_driver_attended ? details.number_of_driver_attended : '--'}
                      </span>
                    </Col>
                    <Col xl="5" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Major Point of Discussion</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.major_issue_before_dtp ? details.major_issue_before_dtp : '--'}
                      </span>
                    </Col>
                    {(details.activity_name.toLowerCase() === 'driver training' && <Col xl="12" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Solutions Given</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.solution_given ? details.solution_given : '--'}
                      </span>
                    </Col>)}
                    <Col xl="12" md="12" xs="12" className='d-flex-column mb-3'>
                      <Label for="company_name" className="mb-1">Feedback by participants</Label>
                      <span className="detail-lbl font-weight-bold text-capitalize">
                        {details.feedback_by_drivers ? details.feedback_by_drivers : '--'}
                      </span>
                    </Col>
                  </Row>
                </>
              }
              {
                details.image_1 || details.image_2 || details.image_3 ?
                  <Row>
                    {
                      details.image_1 || details.image_2 || details.image_3 ?
                        <Col xl="12" md="12" xs="12" className='d-flex-column'>
                          <Label for="company_name">Images</Label>
                        </Col> : ''
                    }
                    {
                      details.image_1 && <Col xl="4" md="12" xs="12" className='d-flex-column'>
                        <img className="activity-img" src={details.image_1} alt='activity-img' />
                        <span className="detail-lbl font-weight-bold text-capitalize">
                          Image 1
                </span>
                      </Col>
                    }
                    {
                      details.image_2 &&
                      <Col xl="4" md="12" xs="12" className='d-flex-column'>
                        <img className="activity-img" src={details.image_2} alt='activity-img' />
                        <span className="detail-lbl font-weight-bold text-capitalize">
                          Image 2
                </span>
                      </Col>
                    }
                    {
                      details.image_3 &&
                      <Col xl="4" md="12" xs="12" className='d-flex-column'>
                        <img className="activity-img" src={details.image_3} alt='activity-img' />
                        <span className="detail-lbl font-weight-bold text-capitalize">
                          Image 3
                </span>
                      </Col>
                    }
                  </Row> : ''
              }
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default ActivityDetail;